
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Get } from 'vuex-pathify';

import { FulfillmentType } from '../../../types/ProductDelivery';
import { ILocalStoreJson } from '../../../types/LocalStore';
import { IProductGroupSelector } from '../../../types/Product';

import FulfillmentOptionComponent from './FulfillmentOption.vue';
import FulfillmentOptionLink from './FulfillmentOptionLink.vue';
import StockSubscriptionFormTrigger from './StockSubscriptionFormTrigger.vue';

@Component({
	name: 'LocalDelivery',
	components: {
		FulfillmentOptionComponent,
		FulfillmentOptionLink,
		StockSubscriptionFormTrigger,
	}
})
export default class LocalDelivery extends Vue {
	@Prop({ type: Boolean, required: false, default: false })
	readonly loading: boolean;

	/* Computed
	============================================*/
	@Get('outOfMarket')
	readonly outOfMarket: boolean;

	@Get('localStore')
	readonly localStore: ILocalStoreJson;

	@Get('product')
	readonly product: any;

	@Get('remainingSelectors')
	readonly remainingSelectors: IProductGroupSelector[];

	@Get('fetchingProduct')
	readonly fetchingProduct: boolean;

	@Get('selectedFulfillmentType')
	readonly selectedFulfillmentType: FulfillmentType;

	@Get('isInStockInStore')
	readonly isInStockInStore: boolean;

	@Get('isDeliveryDisabled')
	readonly isDeliveryDisabled: boolean;

	@Get('hasSelectorError')
	readonly hasSelectorError: boolean;

	@Get('hasSelectedVariant')
	readonly hasSelectedVariant: boolean;

	get isSelected(): boolean {
		return !this.isDisabled && this.fulfillmentOption === this.selectedFulfillmentType;
	}

	get isInSameDayDeliveryWindow(): boolean {
		return this.localStore.localDeliveryInformation.isInSameDayDeliveryWindow;
	}

	get label(): string {
		return this.localStore.localDeliveryInformation.label;
	}

	get disclaimer(): string {
		if (this.isDeliveryDisabled || !this.hasSelectedVariant) return null;

		let disclaimerStr = this.isInSameDayDeliveryWindow
			? '*Order by 2pm local time.'
			: '*Orders placed after 2pm are delivered next day, excluding holidays.';

		// only display inclement weather warning during winter months
		if ([ 11, 12, 1, 2, 3 ].indexOf(new Date().getMonth() + 1) > -1) {
			disclaimerStr += ' Inclement weather may delay delivery.';
		}

		return disclaimerStr;
	}

	get isDisabled(): boolean {
		return this.isDeliveryDisabled
				|| !this.hasSelectedVariant
				|| this.fetchingProduct
				|| this.loading;
	};

	get linkToStockModalText(): string {
		return this.isInStockInStore ? 'Change Store' : 'Check Nearby Stores';
	};

	get inStoreStockMessage(): string {
		if (this.product.notCarriedInStore) return 'Not Carried';
		if (this.isInStockInStore) return this.product.activeLocalDelivery ? 'In Stock' : 'Item Unavailable';
		return 'Out of Stock';
	};

	get stockSubscriptionFormEnabled(): boolean {
		return this.product.backInStockInfo.isProductEligible &&
				!this.isInStockInStore &&
				this.hasSelectedVariant &&
				!this.outOfMarket &&
				!this.fetchingProduct &&
				!this.product.notCarriedInStore;
	}

	/* Data
	============================================*/
	readonly fulfillmentOption: FulfillmentType = FulfillmentType.LocalDelivery;

	/* Methods
	============================================*/
	onChange() {
		if (this.isSelected) return;
		this.$emit('change', this.fulfillmentOption);
	}
}
